import { createTheme } from "@material-ui/core/styles";

// in your theme file that you call `createTheme()`
import { Theme } from "@material-ui/core/styles";

declare module "@material-ui/styles" {
  interface DefaultTheme extends Theme {}
}

declare module "@material-ui/core/styles/createPalette" {
  interface Pallette {
    textTertiary: string;
  }

  interface PaletteOptions {
    textTertiary?: string;
  }
}

const THEME = createTheme({
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  shadows: [
    "none",
    "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
    "0px 4px 8px rgba(0, 0, 0, 0.16)",
    "0px 0px 12px rgba(0, 0, 0, 0.16)",
    "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
    "0px 4px 12px rgba(0, 0, 0, 0.25), 0px 0px 2px rgba(0, 0, 0, 0.16);",
    "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
    "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
    "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
    "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
    "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px…gba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
    "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px…gba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
    "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px…gba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
    "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px…gba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
    "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px…gba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
    "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px…gba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
    "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2p…gba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
    "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2p…gba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
    "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2p…gba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
    "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2p…gba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
    "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3…gba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
    "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3…gba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
    "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3…gba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
    "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3…gba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
    "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3…gba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)"
  ],

  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderColor: "#DDD"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none"
        }
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          height: "36px",
          width: "36px",
          color: "#808080"
        }
      }
    },
    MuiStepLabel: {
      styleOverrides: {
        iconContainer: {
          paddingRight: "20px"
        },
        label: {
          fontSize: "16px",
          fontWeight: 500
        }
      }
    },
    MuiStep: {
      styleOverrides: {
        root: {
          paddingRight: "32px",
          paddingLeft: "32px"
        }
      }
    },
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: "#DDDDDD"
        },
        lineHorizontal: {
          borderBottomWidth: 1,
          borderBottomStyle: "solid"
        },
        lineVertical: {
          marginLeft: 29,
          width: 0,
          borderRightWidth: 1,
          borderRightStyle: "solid"
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "#5F6368"
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        h2: {
          fontSize: "48px",
          lineHeight: "56px",
          fontWeight: "bold"
        },
        h3: {
          fontSize: "18px",
          lineHeight: "24px",
          fontWeight: "bold"
        },
        h4: {
          fontSize: "24px",
          lineHeight: "32px"
        }
      }
    }
  },

  palette: {
    primary: {
      main: "#1329FE"
    },
    secondary: {
      main: "#808080"
    },

    info: {
      main: "#5F6368"
    },

    error: {
      main: "#D93024"
    },
    text: {
      primary: "#202124",
      secondary: "#808080"
    },
    textTertiary: "#B6B6B6"
  }
});

export default THEME;
